import httpClient from './httpClient'

export default {
  getAll(status) {
    return httpClient.get(`requests/${status}`).then(r => r.data)
  },
  get(id) {
    return httpClient.get(`requests/${id}`).then(r => r.data)
  },
  getByVehicle(vehicleId) {
    return httpClient.get(`requests?vehicle=${vehicleId}`).then(r => r.data)
  },
  getByAssociate(userId) {
    return httpClient.get(`requests?associate=${userId}`).then(r => r.data)
  },
  create(data) {
    return httpClient.post('requests', data).then(r => r.data)
  },
  updateWishes(data) {
    return httpClient.put('requests', data).then(r => r.data)
  },
  updateStatus(id, statusCode) {
    return httpClient.put(`requests/${id}/${statusCode}`).then(r => r.data)
  },
  updateComments(id, comments) {
    return httpClient.put(`requests/${id}`, { comments }).then(r => r.data)
  },
  remove(ids) {
    return httpClient.delete(`requests?ids=${ids}`).then(r => r.data)
  },
  removeById(id) {
    return httpClient.delete(`requests?id=${id}`).then(r => r.data)
  }
}
